module.exports = __webpack_public_path__ + "static/Aneta_Koubkova_FirstTime-18d40280ff7860a8db65d2cf2ed499d4.mp3";